// extracted by mini-css-extract-plugin
module.exports = {"comp":"SectionD_comp__ApK39"};